// extracted by mini-css-extract-plugin
export default {"animated-mask":"Loading_animated-mask__e9uYo","moveMask":"Loading_moveMask__pW44B"};